<script setup>
import { ref, computed } from 'vue';
import useContext from '@/composables/useContext'
import DrawerRight from '@/components/DrawerRight.vue';
import CountrySwitcher from '@/components/CountrySwitcher.vue';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

const props = defineProps({
  links: {
    type: Array,
    required: true
  }
});

const { channel } = useContext();
const { websiteText } = useWebsiteTexts();

const showDrawer = ref(false);

const countryName = computed(() => {
  const id = channel.value.displayName;
  return id === '001' ? 'EU' : id || 'N/A';
});

</script>

<template>
  <div class="top-header">
    <div class="top-header__container">
      <div class="top-header__content">
        <div class="language-selector">
          <span class="language-selector__trigger" @click="showDrawer = true">{{websiteText('getmygift__header__shopping').value}} {{ countryName }}</span>
          <DrawerRight :isOpen="showDrawer" @close="showDrawer = false">
            <country-switcher class="desktop-header__country-switcher"
              row-class="desktop-header__country-switcher-item" />
          </DrawerRight>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.top-header__container {
  background-color: #34383d;
}

.top-header__content {
  display: flex;
  justify-content: end;
  align-items: center;
  height: 26px;
  position: relative;
  max-width: calc(var(--site-max-width) + 2rem);
  margin: auto;
  margin-bottom: auto;
  margin-bottom: 1rem;
  padding: 1rem;
}

.language-selector {
  display: flex;
}

.language-selector__trigger {
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
</style>